import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CompaniesTable = _resolveComponent("CompaniesTable")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_ThirdPartyCompanyEdition = _resolveComponent("ThirdPartyCompanyEdition")!
  const _component_MergeCompanies = _resolveComponent("MergeCompanies")!
  const _component_CompaniesImport = _resolveComponent("CompaniesImport")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createBlock(_component_oss_dialog, {
    modelValue: _ctx.dialog,
    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.dialog) = $event)),
    title: _ctx.title,
    "previous-display": _ctx.wizardStep !== 0,
    onPrevious: _ctx.previousStep,
    actions: _ctx.actions,
    width: "60vw"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_window, {
        modelValue: _ctx.wizardStep,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.wizardStep) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_window_item, { value: 0 }, {
            default: _withCtx(() => [
              (_ctx.wizardStep === 0)
                ? (_openBlock(), _createBlock(_component_CompaniesTable, {
                    key: 0,
                    showGenericCompany: false,
                    showNewCompanies: false,
                    showExistingCompanies: false,
                    showCustomerCompanies: true,
                    showSupplierCompanies: true,
                    showOrphelinCompanies: true,
                    showImportCompanies: true,
                    showSelectMergeCompanies: true,
                    showImport: true,
                    actions: _ctx.actions,
                    parentCompanyId: _ctx.selectedCompany.id,
                    onDisableMergeButton: _cache[0] || (_cache[0] = ($event: any) => (_ctx.disableMerging($event))),
                    onSelectCompany: _cache[1] || (_cache[1] = ($event: any) => (_ctx.thirdCompanyEdit($event))),
                    onCompaniesToMerge: _cache[2] || (_cache[2] = ($event: any) => (_ctx.thirdCompaniesMerge($event))),
                    onImportCompanies: _cache[3] || (_cache[3] = ($event: any) => (_ctx.importCompanies($event))),
                    onEmitActions: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setActions()))
                  }, null, 8, ["actions", "parentCompanyId"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: 1 }, {
            default: _withCtx(() => [
              (_ctx.wizardStep === 1)
                ? (_openBlock(), _createBlock(_component_ThirdPartyCompanyEdition, {
                    key: 0,
                    showEditCompany: true,
                    showCompanyContacts: true,
                    showCompanyIBANS: true,
                    showCompanyProducts: _ctx.showProductsTab,
                    showTagRules: true,
                    thirdPartyCompanyId: _ctx.thirdPartyCompany.id,
                    thirdPartyCompanyType: _ctx.thirdPartyCompany.thirdPartyCompanyType,
                    companyId: _ctx.selectedCompany.id,
                    actions: _ctx.actions,
                    onIbanRules: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setCreateIbanValid($event))),
                    onCreateUser: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setCreateUserValid($event))),
                    onActiveTab: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setActiveTab($event))),
                    onStep: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setStepFromChild($event))),
                    onEditMode: _cache[9] || (_cache[9] = ($event: any) => (_ctx.setEditMode($event))),
                    onUpsertDone: _cache[10] || (_cache[10] = ($event: any) => (_ctx.wizardStep = 0)),
                    ref: "thirdPartyCompanyEditionIndex"
                  }, null, 8, ["showCompanyProducts", "thirdPartyCompanyId", "thirdPartyCompanyType", "companyId", "actions"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: 2 }, {
            default: _withCtx(() => [
              (_ctx.wizardStep === 2)
                ? (_openBlock(), _createBlock(_component_MergeCompanies, {
                    key: 0,
                    tpCompaniesIdToMerge: _ctx.tpCompaniesIdToMerge,
                    actions: _ctx.actions,
                    ref: "mergeCompanyIndex",
                    onMergeDone: _cache[11] || (_cache[11] = ($event: any) => (_ctx.previousStep()))
                  }, null, 8, ["tpCompaniesIdToMerge", "actions"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: 3 }, {
            default: _withCtx(() => [
              (_ctx.wizardStep === 3)
                ? (_openBlock(), _createBlock(_component_CompaniesImport, {
                    key: 0,
                    ref: "importComponent",
                    actions: _ctx.actions,
                    documentType: 'CHILD_COMPANIES',
                    selectedCompanyId: _ctx.selectedCompany.id,
                    onDocumentImported: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onDocumentImported())),
                    onBack: _cache[13] || (_cache[13] = ($event: any) => (_ctx.wizardStep = 0))
                  }, null, 8, ["actions", "selectedCompanyId"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["modelValue", "title", "previous-display", "onPrevious", "actions"]))
}